import React from 'react';
import Grid from '@mui/material/Grid';
import FormInputMultiCheckbox from '../../../../common/Forms/FormCheckbox';
import { useDispatch } from 'react-redux';
import {
  setWCare,
  setParole,
  setPrison,
  setOther,
  setCbp,
  setSap,
  setStop,
  setVendor,
  setInactive,
} from '../../../../../redux/organization/organizationForm/organizationFormSlice';

const OrganizationCheckBox = (props) => {
  const dispatch = useDispatch();
  const { control, defaultValue, register } = props;
  return (
    <Grid container>
      <FormInputMultiCheckbox
        name='wCare'
        label='WCare'
        control={control}
        checked={defaultValue?.wCare}
        register={register('wCare', {
          onChange: (e) => dispatch(setWCare(e.target.value)),
        })}
      />
      <FormInputMultiCheckbox
        name='parole'
        label='Parole'
        control={control}
        checked={defaultValue?.parole}
        register={register('parole', {
          onChange: (e) => dispatch(setParole(e.target.value)),
        })}
      />
      <FormInputMultiCheckbox
        name='prison'
        label='Prison'
        control={control}
        checked={defaultValue?.prison}
        register={register('prison', {
          onChange: (e) => dispatch(setPrison(e.target.value)),
        })}
      />
      <FormInputMultiCheckbox
        name='other'
        label='Other'
        control={control}
        checked={defaultValue?.other}
        register={register('other', {
          onChange: (e) => dispatch(setOther(e.target.value)),
        })}
      />
      <FormInputMultiCheckbox
        name='cbp'
        label='CBP'
        control={control}
        checked={defaultValue?.cbp}
        register={register('cbp', {
          onChange: (e) => dispatch(setCbp(e.target.value)),
        })}
      />
      <FormInputMultiCheckbox
        name='sap'
        label='SAP'
        control={control}
        checked={defaultValue?.sap}
        register={register('sap', {
          onChange: (e) => dispatch(setSap(e.target.value)),
        })}
      />
      <FormInputMultiCheckbox
        name='stop'
        label='STOP'
        control={control}
        checked={defaultValue?.stop}
        register={register('stop', {
          onChange: (e) => dispatch(setStop(e.target.value)),
        })}
      />
      <FormInputMultiCheckbox
        name='vendor'
        label='Vendor'
        control={control}
        checked={defaultValue?.vendor}
        register={register('vendor', {
          onChange: (e) => dispatch(setVendor(e.target.value)),
        })}
      />
      <FormInputMultiCheckbox
        name='inactive'
        label='Inactive'
        control={control}
        checked={defaultValue?.inactive}
        register={register('inactive', {
          onChange: (e) => dispatch(setInactive(e.target.value)),
        })}
      />
    </Grid>
  );
};

export default OrganizationCheckBox;
